// extracted by mini-css-extract-plugin
export default {"form-lede":"tenant-entry_form-lede__JDAjo","tooltip":"tenant-entry_tooltip__Cm6fl"};